import { Modal } from "@mui/material";
import styled from "styled-components";
import ButtonComponent from "../button";
import IconDelete from "../../assets/images/icon-delete-2.svg"

const Container = styled.div`
    width: calc(480px - 72px);
    height: calc(194px - 72px);
    padding: 36px;
    border-radius: 16px;
    background-color: #FFFFFF;
    border: 1px solid #F1F1F190;
    box-shadow: 0px 5px 30px 0px #00266F29;
    display: flex;
    flex-direction: column;

    &:focus-visible {
        outline: none;
    }

    .label {
        color: #25368D;
        font-size: 24px;
        font-weight: 500;
        line-height: 35.88px;
        text-align: center;
        margin-bottom: 8px;
    }

    .button-container {
        margin-top: auto;
        margin-bottom: 0px;
        display: flex;
        gap: 24px;

        .button-box {
            width: 50%;
        }
    }
`;

function DeleteModal({
    open,
    title,
    onBack,
    onConfirm,
}) {
    function handleConfirm() {
        onConfirm && onConfirm();
    }
    function handleBack() {
        onBack && onBack();
    }

    return (
        <Modal
            className="content-center"
            open={open || false}
        >
            <Container>
                <div className="label content-center">{title || ""}</div>
                <div className="button-container">
                    <div className="button-box">
                        <ButtonComponent
                            label={"ยกเลิก"}
                            variant={"secondary"}
                            sceenSize={"lg"}
                            style={{ maxWidth: "100%" }}
                            onClick={handleBack}
                        />
                    </div>

                    <div className="button-box">
                        <ButtonComponent
                            label={"ยืนยัน"}
                            variant={"delete"}
                            sceenSize={"lg"}
                            style={{ maxWidth: "100%" }}
                            onClick={handleConfirm}
                        />
                    </div>
                </div>
            </Container>
        </Modal>
    )
}

export default DeleteModal;